import {atom} from 'jotai';
import {
    getMaterialSuppliers,
    getMaterialSupplierProperties,
} from '@/actions/materials/suppliers';
import type {
    MaterialSuppliersState,
    MaterialProperty,
    PropertyOption,
} from '@/types/material-supplier';

const initialState: MaterialSuppliersState = {
    items: [],
    loading: false,
    error: null,
    initialized: false,
};

export const materialSuppliersAtom = atom<MaterialSuppliersState>(initialState);
const supplierPropertiesAtom = atom<MaterialProperty[]>([]);
export const supplierRangesAtom = atom<PropertyOption[]>([]);
export const normalizedBrandToSupplierIdMapAtom = atom<Record<string, string>>(
    {}
);

export const getMaterialSuppliersAtom = atom(null, async (get, set) => {
    try {
        const suppliers = await getMaterialSuppliers();

        set(materialSuppliersAtom, {
            items: suppliers,
            loading: false,
            error: null,
            initialized: true,
        });
    } catch (error) {
        set(materialSuppliersAtom, {
            items: [],
            loading: false,
            error: error instanceof Error ? error.message : 'Unknown error',
            initialized: true,
        });
    }
});

export const getSupplierPropertiesAtom = atom(
    null,
    async (get, set, supplierId: number) => {
        try {
            const properties = await getMaterialSupplierProperties(supplierId);

            if (!properties || !Array.isArray(properties)) {
                return [];
            }

            set(supplierPropertiesAtom, properties);

            const rangeProperty = properties.find(
                (prop) => prop?.name?.toLowerCase() === 'range'
            );

            if (rangeProperty?.values && Array.isArray(rangeProperty.values)) {
                const ranges = rangeProperty.values
                    .filter((val) => val?.id && val?.value)
                    .map((val) => ({
                        id: val.id,
                        value: val.value,
                    }));

                set(supplierRangesAtom, ranges);

                return ranges;
            }

            const collectionProperty = properties.find(
                (prop) => prop?.name?.toLowerCase() === 'collection'
            );

            if (
                collectionProperty?.values &&
                Array.isArray(collectionProperty.values)
            ) {
                const ranges = collectionProperty.values
                    .filter((val) => val?.id && val?.value)
                    .map((val) => ({
                        id: val.id,
                        value: val.value,
                    }));

                set(supplierRangesAtom, ranges);

                return ranges;
            }

            set(supplierRangesAtom, []);

            return [];
        } catch {
            set(supplierRangesAtom, []);

            return [];
        }
    }
);
